import { useState, createContext, useContext } from "react";

const UserContext = createContext();

export const useUser = () => {
  return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("netifyUser") || null)
  );

  const updateUser = (loggedUser) => {
    if (loggedUser) {
      setUser(loggedUser);

      localStorage.setItem("netifyUser", JSON.stringify(loggedUser));
    }
  };

  const removeUser = () => {
    localStorage.removeItem("netifyUser");

    setUser(null);
  };

  const value = {
    user,
    updateUser,
    removeUser,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
